<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <chart-card
            id="dealerInvestmentAmountsChart"
            [title]="texts.evolutionExpenditureChart.title"
            [error]="chartError"
            [isLoading]="!chartData()[0].organizationId"
            [series]="chartSeries"
            [dataLabels]="dataLabels"
            [stacked]="true"
            [xaxisCategories]="xaxisCategories"
            [yaxis]="yaxis"
            [precision]="texts.evolutionExpenditureChart.precision"
            [xaxisTitle]="texts.evolutionExpenditureChart.xaxisTitle"
            class="h-100">
        </chart-card>
    </div>
</div>
